module.exports = __webpack_public_path__ + "img/edit_icon.8251645f.svg";